import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { authAPI } from '../services/api';

function AdminLogin({ onLogin }) {
    const [formData, setFormData] = useState({
        email: '',
        password: '',
    });
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await authAPI.login(formData.email, formData.password);

            if (response.data.user.role !== 'admin') {
                toast.error('Access denied. Admin only.');
                setLoading(false);
                return;
            }

            toast.success('Login successful!');
            onLogin(response.data.user, response.data.token);
        } catch (error) {
            toast.error(error.response?.data?.message || 'Login failed');
            setLoading(false);
        }
    };

    return (
        <div className="login-page">
            <div className="login-container">
                <div className="login-card">
                    <h1>Admin Login</h1>
                    <p className="subtitle">Novantix Innovation Technology</p>

                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label htmlFor="email">Email</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                                placeholder="Enter your email"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="password">Password</label>
                            <input
                                type="password"
                                id="password"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                required
                                placeholder="Enter your password"
                            />
                        </div>

                        <button type="submit" className="btn btn-primary" disabled={loading}>
                            {loading ? 'Logging in...' : 'Login'}
                        </button>
                    </form>

                    <div className="login-footer">
                        <a href="/login">Student Login</a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AdminLogin;
